module.exports = __webpack_public_path__ + "static/img/custom-concrete-pedestal.45aa867.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/pedestals/custom-concrete-pedestal.jpg
// module id = 718
// module chunks = 0